import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { NotesListDetails, saveNotes } from './actions/notesActions';
import { renderCheckBox, renderTextArea, renderTextField } from "../../../../../../components/reduxFields";
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../components/buttons';
import SmallLoader from '../../../../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
// import { displayCustomError } from '../../../../../../actions/utilAction';


class NotesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      notesId: props.notesId
    };
  }

  componentWillMount() {
    if (this.state.notesId) {
      this.props.NotesListDetails(this.state.notesId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let postData = {
      "id": this.props.notesId || 0,
      "patientId": this.props.patientId,
      "title": formProps.title,
      "notes":  formProps.notes || true,
      "isActive": formProps.isActive || false,      
    }
    this.props.clearFieldErrorArray();
    this.props.saveNotes(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.notesId || 0,
        'patientId': this.props.patientId ? parseInt(this.props.patientId) : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return <Dialog className="custom_modal" title={this.state.notesId ? "Edit Notes" : "Add Notes"} modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 require mt-30">
                  <Field
                   autoFocus={true}
                   name="title"
                   label="Title"
                   type="text"
                   maxLength="100"
                   //onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Title')}
                   //customError={displayCustomError('TITLE', this.props.fieldError)}        
                   component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 require mt-30">
                  <Field 
                   name="notes"
                   label="Note"
                   type="text"
                   maxLength="4000"
                   component={renderTextArea} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>;
  }
}

NotesModal = reduxForm({
    form: 'NotesModalForm',
    validate,
    enableReinitialize: true,
})(NotesModal);


function mapStateToProps(state, ownProps) { 

  let initialValueData = {
    isActive: true,
  };
  if (ownProps.notesId && state.patient_notes.notesDetail) {
    initialValueData = state.patient_notes.notesDetail.data || null;
  } 

  return {
    loading: state.patient_notes.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{NotesListDetails, checkFieldExistence, clearFieldErrorArray, saveNotes})(NotesModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/Add_Notes_Modal.js